module.exports = __webpack_public_path__ + "static/media/214x152_5 copy.799153e9.png";